import React from "react";
import { Link, LinkProps } from "react-router-dom";

import style from "./style.module.scss";

export interface TextLinkProps extends Omit<LinkProps, "to"> {
  link: LinkProps["to"];
  text?: React.ReactNode;
  external?: boolean;
  fontSize?: React.CSSProperties["fontSize"];
  fontFamily?: React.CSSProperties["fontFamily"];
  fontWeight?: React.CSSProperties["fontWeight"];
}

export default function TextLink({
  link,
  text,
  children,
  external,
  className = "",
  fontSize,
  fontFamily,
  fontWeight,
  style: inlineStyle,
  target,
  rel,
  replace,
  innerRef,
  component,
  ...linkProps
}: TextLinkProps) {
  const linkClassName = [style.textLink, className]
    .filter(Boolean)
    .join(" ");
  const linkStyle: React.CSSProperties = {
    ...inlineStyle,
    ...(fontSize !== undefined && { fontSize }),
    ...(fontFamily !== undefined && { fontFamily }),
    ...(fontWeight !== undefined && { fontWeight }),
  };
  const content = children !== undefined ? children : text;
  const isExternalLink = external !== undefined
    ? external
    : typeof link === "string" && /^(?:[a-z][a-z\d+.-]*:|\/\/)/i.test(link);

  if (isExternalLink && typeof link === "string") {
    const externalRel = target === "_blank"
      ? rel || "noopener noreferrer"
      : rel;

    return (
      <a
        href={link}
        className={linkClassName}
        style={linkStyle}
        target={target}
        rel={externalRel}
        {...linkProps}
      >
        {content}
      </a>
    );
  }

  return (
    <Link
      to={link}
      className={linkClassName}
      style={linkStyle}
      target={target}
      rel={rel}
      replace={replace}
      innerRef={innerRef}
      component={component}
      {...linkProps}
    >
      {content}
    </Link>
  );
}
